import * as React from 'react';

import { useClickTracker } from '@shared-ui/clickstream-analytics-context';

import { FilterOptionModel } from './filter-types';

import { UitkCheckbox } from 'uitk-react-checkbox';

export interface CheckboxInputProps extends FilterOptionModel {
  index?: number;
  checked?: boolean;
  handleClick?: (Event) => void;
  handleChange?: (Event) => void;
  firstIndex?: number;
  lastIndex?: number;
  description?: string;
  isRange?: boolean;
  filterType?: string;
}

export const CheckboxInput = (props: CheckboxInputProps) => {
  const track = useClickTracker();

  const handleChange = event => {
    const { handleChange, name, value, filterType, index } = props;

    const target = event.target;
    const { checked } = target;

    const categoryStr = `${filterType ? `.${filterType}` : ''}`;
    const oneBasedIndex = index + 1;
    track(`${name}${categoryStr}.${value}.${!props.checked}:${oneBasedIndex}`, `${name}.${value}`);

    if (typeof handleChange === 'function') {
      handleChange({
        target: {
          name,
          value,
          checked,
          filterType,
        },
      });
    }
  };

  const { checked, index, label, description, name, value, firstIndex, lastIndex, isRange, ariaLabel } = props;
  const checkboxId = `${name}-${index}-${value}`;
  const checkboxAttributes = {
    id: checkboxId,
    key: checkboxId,
    name,
    value,
    checked,
    onChange: handleChange,
    description,
    disabled: false,
  };

  if (isRange && index > firstIndex && index < lastIndex) {
    checkboxAttributes.disabled = true;
    checkboxAttributes.checked = true;
  }

  return (
    <UitkCheckbox aria-label={ariaLabel} key={checkboxAttributes.id} {...checkboxAttributes}>
      {label}
    </UitkCheckbox>
  );
};
